<template>
    <div v-if="!totalError" class="w-full"> 
        <!--AMOUNT SEND-->
        <span class="text-600">{{ lang('amount_send') }}: </span>
        <div v-if="currencyGetList && loaded" class="w-full mt-2 mb-3">
            <InputAmount :amount="amountGet" :currency="currencyGet" :currencies="currencyGetList" :min="minGetLimit" :max="maxGetLimit" 
                @update:amount="val => amountGet = val" @update:currency="val => currencyGet = val"
                :disableInput="false" :disableSelect="false" digits="2" :isClearButtons="false" :isRequest="false"/>
        </div>
        <Skeleton v-else height="3rem" class="mt-2 mb-3 border-round-xl"/>

        <!--AMOUNT RECEIVE-->
        <span class="text-600">{{ lang('amount_receive') }}:</span>
        <div class="w-full mt-2 mb-3" v-if="currencyGetList && loaded">
            <InputAmount :amount="amountReceive" :currency="currencyReceive" :currencies="currencyReceiveList" :min="null" :max="null" 
                @update:amount="val => amountReceive = val"  @update:currency="val => currencyReceive = val"
                :disableInput="true" :disableSelect="true" digits="2" :isClearButtons="false" :isRequest="false" currencyTitleKey="currency_receive"/>
        </div>
        <Skeleton v-if="!loaded || !currencyReceive" height="3rem" class="mt-2 mb-3 border-round-xl"/>

        <!--SENDER NAME-->
        <div v-if="user_name" class="flex flex-row mb-3">
            <span class="flex text-500">{{ lang('sender_name') }}: &nbsp</span>
            <span class="flex text-500 cursor-pointer" @click="go_profile()"> 
                {{ user_name }} &nbsp
            </span>
            <span class="pi pi-pencil text-500 cursor-pointer" @click="go_profile()"></span>
        </div>

        <!--GET PAY SYSTEM-->
        <span class="text-600">{{ lang('payment_method') }}:</span>
        <PaymentSysDropdown v-if="loaded && getPaySys" :pay_sys="getPaySys" :currency="currencyGet" type="get" :list="getPaySysListGrouped"
            @update:pay-sys="val => chooseGetPaySys(val)" />
        <Skeleton v-else height="3rem" class="mt-2 mb-3 border-round-xl"/>

        <!--DESCRIPTION-->
        <div v-if="loaded">
            <div v-if="!hide_desc">
                <span class="text-color-secondary">{{ lang('description') }}:</span>
                <Textarea rows="5" cols="20" class="w-full surface-border border-2 border-round-xl text-sm p-2 mt-2 mb-3" 
                    :value="description" :placeholder="lang('description_text')"
                    @input="description = $event.target.value"
                    style="resize: none !important; font-family: inherit;"
                    />
            </div>

            <div v-if="hide_desc" class="w-full mb-3">
                <span class="cursor-pointer text-primary" @click="showDesc(true)">
                    <span class="mr-2">{{ lang('show_description') }}</span>
                    <i class="pi pi-pen-to-square text-600 mr-2 text-primary"></i>
                </span>
            </div>

            <div v-if="!hide_desc" class="w-full mb-3">
                <span class="cursor-pointer text-primary" @click="showDesc(false)">
                    <span class="mr-2">{{ lang('hide_description') }}</span>
                    <i class="pi pi-replay text-600 mr-2 text-primary"></i>
                </span>
            </div>
        </div>
        <Skeleton v-else height="5rem" class="mt-2 mb-3"/>

        <!--BUTTON-->
        <div class="field w-full" v-if="!isAuth">
            <Button @click="go_registration(bill.hash)" :label="lang('button_bill')+'*'" 
                class="w-full border-round-2xl" :disabled="!loaded" :loading="isLoading" size="large" />
        </div>

        <div class="field w-full" v-if="isAuth">
            <Button @click="Create()" :label="lang('button_bill')" :disabled="!loaded || isLoading || !amountGet" :loading="isLoading"
                class="w-full border-round-2xl" size="large" />
        </div>
        
        <span v-if="!isAuth" class="field flex text-sm text-500 mt-2 align-items-center justify-content-center w-full text-center">
            {{ lang('before') }} *
        </span>

        <Dialog v-model:visible="show_profile" modal :header="lang('profile')" 
            class="max-w-30rem ml-4 mr-4 border-round-xl">
            <Profile />
        </Dialog>

    </div>

    <!--ERRORS-->
    <div v-if="totalError" class="w-full max-w-30rem">
        <InlineMessage severity="warn" class="border-round-xl">
            {{ 
                (totalErrorMessage == 'Error getting all merchs') ? lang('critical_error') : totalErrorMessage
            }}
        </InlineMessage>
    </div>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Event from '@/assets/js/Event'
import BigNumber from 'bignumber.js'
import Helper from '@/assets/js/Helper'
import { reactive, ref } from 'vue'
                                import Profile from '@/components/personal/profile/Index.vue' 
import FbConversion from '@/assets/js/classes/FbConversion.js'
import TransferCalculation from '@/assets/js/classes/TransferCalculation.js'
import InputAmount from '@/components/widgets/transfer/InputAmount.vue'
import PaymentSysDropdown from '@/components/widgets/transfer/PaymentSysDropdown.vue'
import { PaymentSystemList, BankList } from '@/assets/js/classes/PaymentSystem.js'
import { CurrencyList} from '@/assets/js/classes/Currency.js'
import { RateList } from '@/assets/js/classes/Rate.js'

export default {
	name: 'TransferCreateFromBill',
    props: {
        bill: {
            type: Object,
            required: true
        },
        fix_amount: {
            type: Boolean,
            default: false
        },
    },
	data() {
		return {
            loaded: false,
            recalculating: false,

            arrRates: [],
            arrCurrencies: [],

			amountGet: null,
            amountSend: null,

            currencyGet: null,
            currencyGetList: [],

            currencyReceive: null,
            currencyReceiveList: [],

            minGetLimit: null,
			maxGetLimit: null,
            minSendLimit: null,
            maxSendLimit: null,

            getPaySys: null,
            getPaySysList: [],
            getPaySysListGrouped: {},
            sendPaySys: null,
            receivePaySysList: [],

            rate_obj: {},

            payment_popup: false,

            description: null,
            hide_desc: true,
			
            isLoading: false,
            submitted: false,
            info_display: false,
			
            rate: null,
			rate_display: false,

            rates: [],
            banks_obj: [],
            arrBanks: [],
            bank_choosen: null,
            bank_popup: false,
			
            totalError: false,
            totalErrorMessage: '',

            show_profile: false,
		}
	},
    components: {
        Profile,
        InputAmount,
        PaymentSysDropdown,
    },
    // задаем переменные для валидации
    setup () {
        const react = reactive({
            recalculating_: false,
        })
        return { react }
    },
	watch: {
        amountGet: function () {
            if(this.loaded && !this.recalculating){
                this.recalculating = true
			    this.Recalculate('amount_get').then(() => {
                    this.recalculating = false
                })
            }
		},
        amountReceive: function () {
            if(this.loaded && !this.recalculating){
                this.recalculating = true
			    this.Recalculate('amount_receive').then(() => {
                    this.recalculating = false
                })
            }
		},
		currencyGet: function (that) {
            if(this.loaded && !this.recalculating){
                this.recalculating = true
			    this.Recalculate('currency_get').then(() => {
                    this.recalculating = false
                })
            }
		},
        currencyReceive: function (that) {
            if(this.loaded && !this.recalculating){
			    this.Recalculate('currency_receive').then(() => {
                    this.recalculating = false
                })
            }
		},
        currencyReceive: function (that) {
            if(this.loaded && !this.recalculating){
			    this.Recalculate('currencyReceive')
            }
		},
	},
	methods: {
        getDescTitle(paysys){
            if(!paysys || !paysys.description) return ''
            return paysys.description[this.lang_]
        },
        getTypeTitle(paysys){
            if(!paysys || !paysys.type) return ''
            switch (paysys.type) {
                case 'card': return this.lang('type_card')
                case 'stock': return this.lang('type_stock')
                case 'sbp': return this.lang('type_sbp')
                case 'atm': return this.lang('type_atm')
                case 'swift': return this.lang('type_swift')
                case 'office': return this.lang('type_office')
                case 'crypto': return this.lang('type_crypto')
                default: return ''
            }
        },
        getPaySysImage(pay_sys){
            return `/images/svg/pays/${pay_sys.type}.svg`
        },
        getCurImage(cur){
            if(!cur || !cur.image) return ''
            return cur.image
        },
        showDesc(val){
            this.hide_desc = !val
            if(!val) this.description = null
        },
        getCurSign(cur){
            if(!cur || !cur.sign) return ''
            return cur.sign
        },
        get_code(obj){
            if(!obj || obj.code == undefined) return ''
            return obj.code
        },
        split_num(num){
            const bNum = new BigNumber(num)
            if(bNum.isNaN()) return ''
            const strNum = bNum.toFixed(0)
            return this.helper.format_amount_nocur(strNum, 0)
        },
        payment_popup_show(){
            this.payment_popup = true
        },
        show_info(){
            if(this.info_display){
                this.info_display = false
            } else {
                this.info_display = true
            }
        },
        lang(value){
            return this.$t(`views.bill.${value}`)
        },
        getBankByCode(code){
            if(!code) return null
            if(!this.banks_obj) return null
            const arrList = Object.values(this.banks_obj)
            for(let i = 0; i < arrList.length; i++){
                if(arrList[i].code == code) return arrList[i]
            }
            return null
        },
        // определение платежных систем
        recognizePays(rateObj, type, filterCodes=null){
            if(!this.arrPaymetSystems) return []
            let result = []

            const banks = (type=='get') ? rateObj.get_banks : rateObj.send_banks
    
            for(let j = 0; j < banks.length; j++){
                const bank = banks[j]
                const bankCode = bank.code
                const payCode = bank.type
                if(!bankCode) continue

                const bankObj = this.getBankByCode(bankCode)
                if(!bankObj) continue

                const payObj = this.getPaySysByCode(payCode)
                if(!payObj) continue
                

                // для atm проверяем наличие списка сумм
                if(bankObj.type == 'atm' && !bankObj.amount_list) continue
                if(filterCodes && !filterCodes.includes(payCode)) continue

                const item = {
                    code:                       bank.code,      
                    type:                       bank.type,       
                    pay_sys: {
                        code:                   bank.code,       
                        type:                   bank.type,       
                        comissions:             (payObj.comissions) ? payObj.comissions : {percent: 0, fix: 0},
                    } ,   
                    comissions:                 (bankObj.comissions) ? bankObj.comissions : {percent: 0, fix: 0},
                    sort:                       (bankObj.sort) ? bankObj.sort : 0,
                    description:                (bankObj.descriptions) ? bankObj.descriptions : {en: '-', ru: '-'},
                    titles:                     (bankObj.titles) ? bankObj.titles : {en: '-', ru: '-'},
                    image:                      bankObj.image,
                    recipient_fields:           (bankObj.recipient_fields) ? bankObj.recipient_fields : [],
                    recipient_fields_required:  (bankObj.recipient_fields_required) ? bankObj.recipient_fields_required : [],
                    amount_list:                (bankObj.amount_list) ? bankObj.amount_list : [],
                    limits: {
                        min:                    (bank.min) ? bank.min : 0,
                        max:                    (bank.max) ? bank.max : 0
                    },
                }
                result.push(item)
            }
            // удалить дубли из объекта объектов
            let unique = {}
            result.forEach(function(i) {
                if(!unique[i.code]) {
                    unique[i.code] = i
                }
            })
            result = Object.values(result)
            // сортируем по sort
            result.sort((a, b) => a.sort - b.sort)
            // сортировка по limits max по убыванию
            result.sort((a, b) => b.limits.max - a.limits.max)
            return result
        },
        getPaySysByCode(code){
            if(!code) return null
            if(!this.arrPaymetSystems) return null
            const arrList = Object.values(this.arrPaymetSystems)
            for(let i = 0; i < arrList.length; i++){
                if(arrList[i].code == code) return arrList[i]
            }
            return null
        },
        rateHasSendBankCode(rate, bankCode){
            if(!rate || !rate.send_banks || rate.send_banks.length<=0) return false
            for(let i = 0; i < rate.send_banks.length; i++){
                if(rate.send_banks[i].code == bankCode) return true
            }
            return false
        },
        // перерасчет
		async Recalculate(from = null) {

            console.log('from:', from)

            // проверяем поля счета
            if(!this.bill || !this.bill.recipient || !this.bill.recipient.currency_code || !this.bill.recipient.bank_code) {
                this.totalError = true
                this.totalErrorMessage = this.lang('err_bill_dont_exist')
                return
            }
            // const bill_bank_code = (this.bill.recipient.bank_code) ? this.bill.recipient.bank_code : null
            const bill_bank_code = 'internal'
            // const bill_currency_code = (this.bill.recipient.currency_code) ? this.bill.recipient.currency_code : null
            const bill_currency_code = 'usdt'
            const bill_amount = (this.bill.amount) ? this.bill.amount.$numberDecimal : null

            console.log('bill_bank_code', bill_bank_code)
            console.log('bill_currency_code', bill_currency_code)
            console.log('bill_amount', bill_amount)

            if(from=='start'){
                // определяем валюту для получения (по коду из счета)
                this.currencyReceive = this.arrCurrencies[bill_currency_code]
                this.currencyReceiveList = [this.currencyReceive]

                // определяем валюты доступные для отправки
                const filteredRates = this.arrRates.filter(r => r.to_currency_code == this.currencyReceive.code)
                this.currencyGetList = this.getSendCurrencies(filteredRates)

                if(this.currencyGetList.length <= 0) {
                    this.totalError = true
                    this.totalErrorMessage = this.lang('err_no_currency_get')
                    return
                }
            }
            console.log('currencyReceive', this.currencyReceive)
            console.log('currencyReceiveList', this.currencyReceiveList)
            console.log('currencyGetList', this.currencyGetList)

            // если валюта отправки не определена - берем первую
            if(from=='start' && (!this.currencyGet || !this.currencyGet.code)){
                this.currencyGet = this.currencyGetList[0]
            } 

            // если валюта отправки не определена
            if(!this.currencyGet || !this.currencyGet.code) {
                this.totalError = true
                this.totalErrorMessage = this.lang('err_no_currency_get')
                return
            }

            // Определяем объект расчета
            const CALC = new TransferCalculation({})
            CALC.from_currency_code = this.currencyGet.code
            CALC.to_currency_code = this.currencyReceive.code

            // Ищем текущий курс
            const rate = this.getRateFromArray(this.arrRates, this.currencyGet.code, this.currencyReceive.code)
            if(!rate) {
                this.totalError = true
                this.totalErrorMessage = 'No rate found' // TODO: добавить сообщение об ошибке
                return
            }
            console.log('RATE FOUND: ', rate)

            // Задаем курс
            CALC.setRate(rate, 'bill')

            console.log('CALC RATE OBJ: ', CALC.toObject())

            // определяем платежки и устанавливаем лимиты
            if(from=='start' || from=='currency_get'){
                // определяем платежные системы (обновляем если перевыбрана валюта отправки)
                this.getPaySysList = await PaymentSystemList.RecognizePays(rate, 'get', this.$store).then(r=>r)
                this.getPaySys = (this.getPaySysList[0]) ? this.getPaySysList[0] : null
                this.getPaySysListGrouped = PaymentSystemList.GroupByType(this.getPaySysList)
                this.receivePaySysList = await PaymentSystemList.RecognizePays(rate, 'send', this.$store).then(r=>r)
                this.receivePaySys = this.getInternalBank(this.receivePaySysList)

                console.log('getPaySysList', this.getPaySysList)
                console.log('getPaySysList', this.getPaySysList)
                console.log('receivePaySysList', this.receivePaySysList)

                if(!this.getPaySys || !this.receivePaySys) {
                    this.totalError = true
                    this.totalErrorMessage = this.lang('err_payment_system')
                    return
                }
            }

            // Задаем платежные системы            
            CALC.setGetPaySys(this.getPaySys.pay_sys)
            CALC.setSendPaySys(this.receivePaySys.pay_sys)

            // Банки
            CALC.setGetBank(this.getPaySys.bank)
            CALC.setSendBank(this.receivePaySys.bank)


            // Корректировка мерчантов в зависимости от типа платежной системы
            if(this.getPaySys.pay_sys.type!='merchant') CALC.merchants.get.percent = 0
            if(this.receivePaySys.pay_sys.type!='merchant') CALC.merchants.send.percent = 0

            this.minGetLimit = CALC.getMinGetLimit()
            this.maxGetLimit = CALC.getMaxGetLimit()

            console.log('MIN GET: ', this.minGetLimit)
            console.log('MAX GET: ', this.maxGetLimit)

            if(from=='start' || from=='currency_get' || from == 'getPaySys'){
                this.amountGet = this.minGetLimit
            }

            const bMinGetLimit = new BigNumber(this.minGetLimit)
            const bMaxGetLimit = new BigNumber(this.maxGetLimit)
            const bAmountSend = new BigNumber(this.amountReceive)
            if(bAmountSend.isLessThan(bMinGetLimit)) this.amountReceive = this.minGetLimit
            if(bAmountSend.isGreaterThan(bMaxGetLimit)) this.amountReceive = this.maxGetLimit
            
            // задаем сумму для расчета
            CALC.sender.amount = new BigNumber(this.amountGet)
            CALC.recipient.amount_usdt = CALC.calcRecipientAmountUsdt() 
            CALC.recipient.amount = CALC.calcRecipientAmount() 
            this.amountReceive = CALC.recipient.amount.toFixed(16)

            console.log("CALC 2", CALC.toObject())

            CALC.calcResultRate()
            this.CALC = CALC    

            return
		},
        chooseGetPaySys(item){
            if(this.loaded && !this.isRecalculating){
                this.getPaySys = this.setGetPaySys(item)
                this.Recalculate('get_pay_sys', this.filterPaySys).then(res => {
                    this.isRecalculating = false
                })
            }
        },
		setGetPaySys(item) {
            if(!this.getPaySysList) return null
            const isPayCode = (item && item.pay_sys && item.pay_sys.code) ? item.pay_sys.code : null
            const isBankCode = (item && item.bank && item.bank.code) ? item.bank.code : null
			for (const [k, v] of Object.entries(this.getPaySysList)) {
				if (isBankCode) { if (v.bank && v.bank.code == isBankCode) return v } 
                else { if (v.pay_sys && v.pay_sys.code == isPayCode) return v }
			}
			return null
		},
        getInternalBank(array){
            if(!array || array.length <= 0) return null
            for(let i = 0; i < array.length; i++){
                if(array[i].pay_sys && array[i].pay_sys.type && array[i].pay_sys.type == 'internal') return array[i]
            }
            return null
        },
        getBankCodeFromPaySys(obj){
            if(!obj || !obj.bank || !obj.bank.code) return null
            return obj.bank.code
        },
        // расчет суммы к получению
        calcSendAmount(amountSend, rate, coms){
            if(!amountSend) return 0
            if(!rate) return 0
            if(!coms) return 0
            const rateGet = (rate.rates && rate.rates.get) ? rate.rates.get : 0
            if(!rateGet) return 0
            const rateSend = (rate.rates && rate.rates.send) ? rate.rates.send : 0
            if(!rateSend) return 0

            const bRateGet = new BigNumber(rateGet)
            const getAmountUsdt = new BigNumber(amountSend).multipliedBy(bRateGet)
            const comsGetPayUsdt = new BigNumber(coms.get.pay_sys.percent).multipliedBy(getAmountUsdt)
            const comsGetPayFixUsdt = new BigNumber(coms.get.pay_sys.fix)
            const comsSendPayUsdt = new BigNumber(coms.send.pay_sys.percent).multipliedBy(getAmountUsdt)
            const comsSendPayFixUsdt = new BigNumber(coms.send.pay_sys.fix)
            const comsSendBankUsdt = new BigNumber(coms.send.bank.percent).multipliedBy(getAmountUsdt)
            const comsSendBankFixUsdt = new BigNumber(coms.send.bank.fix)
            const comsServiceUsdt = new BigNumber(coms.service).multipliedBy(getAmountUsdt)
            const sendAmountUsdt = getAmountUsdt.minus(comsGetPayUsdt).minus(comsGetPayFixUsdt).minus(comsSendPayUsdt).minus(comsSendPayFixUsdt).minus(comsSendBankUsdt).minus(comsSendBankFixUsdt).minus(comsServiceUsdt)
            const bRateSend = new BigNumber(rateSend)
            const sendAmount = sendAmountUsdt.multipliedBy(bRateSend)
            return sendAmount.toNumber()
        },
        // расчет суммы к отправке
        calcGetAmount(amountReceive, rate, coms){
            if(!rate) return 0
            if(!coms) return 0
            if(!amountReceive) return 0
            const rateGet = (rate.rates && rate.rates.get) ? rate.rates.get : 0
            if(!rateGet) return 0
            const rateSend = (rate.rates && rate.rates.send) ? rate.rates.send : 0
            if(!rateSend) return 0

            const bRateSend = new BigNumber(rateSend)
            const sendAmountUsdt = new BigNumber(amountReceive).dividedBy(bRateSend)
            const comsGetPayPercent = new BigNumber(coms.get.pay_sys.percent)
            const comsGetPayFixUsdt = new BigNumber(coms.get.pay_sys.fix)
            const comsSendPayPercent = new BigNumber(coms.send.pay_sys.percent)
            const comsSendPayFixUsdt = new BigNumber(coms.send.pay_sys.fix)
            const comsSendBankPercent = new BigNumber(coms.send.bank.percent)
            const comsSendBankFixUsdt = new BigNumber(coms.send.bank.fix)
            const comsService = new BigNumber(coms.service)
            const fixSum = sendAmountUsdt.plus(comsGetPayFixUsdt).plus(comsSendPayFixUsdt).plus(comsSendBankFixUsdt)
            const one = new BigNumber(1)
            const percentSum = one.minus(comsGetPayPercent).minus(comsSendPayPercent).minus(comsSendBankPercent).minus(comsService)
            const bRateGet = new BigNumber(rateGet)
            const sendAmount = fixSum.dividedBy(percentSum).dividedBy(bRateGet)
            return sendAmount.toNumber()
        },
        choose_payment(code){
            if(this.loaded && !this.recalculating){
                let choosen_method = this.choose_payment_system(code)
                if (choosen_method) this.getPaySys = choosen_method
            }
            this.payment_popup = false

            this.recalculating = true
            this.Recalculate('getPaySys').then(res => {
                this.recalculating = false
            })
        },
		choose_payment_system(code) {
            if(!this.getPaySysList) return null
			for (const [k, v] of Object.entries(this.getPaySysList)) {
				if (v.code == code) return v
			}
			return null
		},
		show_rate_display() {
			if(this.info_display) this.rate_display = true
		},
		go_registration(bill_hash=null) {
            let url = '/reg/'
            if(bill_hash) url = url + '?redirect_url=/bill/'+bill_hash

            this.event.send('transferCreateReg')

            //отправляем на регистрацию c параметром
            this.$router.push({
                path: url,
                query: {redirect_url: '/bill/'+bill_hash}
            })
		},
		showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        go_profile(){
            this.show_profile = true
        },
        // форматирование списка платежных систем
        formatPaymentSystems(array){
            return this.helper.formatPaymentSystems(array)
        },
        // форматирование списка банков
        formatBankList(array){
            return this.helper.formatBankList(array)
        },
        getRateFromArray(rates_array, from_currency_code, to_currency_code){
            if(!rates_array || !rates_array.length) return null
            for(let i = 0; i < rates_array.length; i++){
                if(rates_array[i].from_currency_code == from_currency_code && rates_array[i].to_currency_code == to_currency_code) 
                    return rates_array[i]
            }
            return null
        },
        // Получение массива валют отправки
        getSendCurrencies(filteredRates){
            if(!filteredRates) return []
            if(!Array.isArray(filteredRates) || !filteredRates.length) return []
            if(!this.arrCurrencies || Object.keys(this.arrCurrencies).length === 0) return []
            let currencies_obj = {}
            for (const [k, v] of Object.entries(this.arrCurrencies)) {
                for(let i = 0; i < filteredRates.length; i++) {
                    if(filteredRates[i].from_currency_code == v.code) currencies_obj[v.code] = v
                }
            }
            const values = Object.values(currencies_obj)
            values.sort((a, b) => {
                const valA = a.sort !== undefined ? a.sort : 9999
                const valB = b.sort !== undefined ? b.sort : 9999
                return valA - valB
            })
            return values
        },
        //создание перевода
        async Create(){
            this.isLoading = true 
            this.submitted = true

            console.log("CALC", this.CALC.toObject())

            let fbp, fbc, url
            try{
                fbp = this.helper.getFbp()
                fbc = this.helper.getFbc()
                url = this.helper.getUrl()
            } catch(e) {
                console.log('error', e)
            }

            const data = {
                hash: this.bill.hash,
                currency_code: this.get_code(this.currencyGet),
                amount_send:  this.CALC.sender.amount.toFixed(16),
                amount_receive: this.CALC.recipient.amount.toFixed(16),
                bank_code: this.getBankCodeFromPaySys(this.getPaySys),
                payment_system_code: this.getPaySys.pay_sys.code,
                payment_system_type: this.getPaySys.pay_sys.type,
                rate: this.CALC.rate.value.toString(),
                description: this.description,
                source: (this.isTgApp) ? 'tgapp' : 'web',
                browser: {
                    fbp: fbp,
                    fbc: fbc,
                    url: url
                }
            }

            console.log('create data', data)

            let transfer = {}

            try {
                transfer = await this.connect.bill_to_pay(data).then(res=>res)
                console.log('result', transfer)
                if(transfer.result && transfer.data) {
                    //успешно создали трансфер
                    this.showMess('success', this.lang('success_title'), this.lang('success_subtitle'))

                    // отправляем событие об успешном создании перевода
                    try {
                        const trId = (transfer.data && transfer.data._id) ? transfer.data._id : null
                        const trSenderId = (transfer.data && transfer.data.sender && transfer.data.sender.user_id) ? transfer.data.sender.user_id : null
                        const eventId = (trId) ? 'transfer-' + trId : null
                        const date = (transfer.data && transfer.data.dates && transfer.data.dates.created) ? transfer.data.dates.created : null
                        const timestamp = Math.floor(date / 1000)
                        const userAgent = this.helper.getUserAgent()

                        let fbConv = new FbConversion('transferCreate')
                        if(eventId)     fbConv.setId(eventId)
                        if(trSenderId)  fbConv.setExternalId(trSenderId)
                        if(timestamp)   fbConv.setTime(timestamp)
                        if(userAgent)   fbConv.setUserAgent(userAgent)
                        if(url)         fbConv.setUrl(url)
                        if(fbp)         fbConv.setFbp(fbp)
                        if(fbc)         fbConv.setFbc(fbc)
                        const eventData = fbConv.get()

                        this.event.send('transferCreate', eventData) 
                    } catch (e) {
                        console.log('error send event', e)
                    }

                    this.$router.push({path: '/personal/transfer/'+transfer.data._id})
                } else {
                    // TODO: добавить amounts_not_equal - расхождение сумм
                    // if(transfer.error && transfer.error == 'rates_been_updated') this.refresh()     
                    if(transfer.error && transfer.error == 'test_return') {
                        this.showMess('success', 'Успех', 'Тестовый режим, перевод не создан') 
                    } else {
                        if(transfer.message) this.showMess('error', this.lang('error_title'), transfer.message)
                        else this.showMess('error', this.lang('error_title'), '')
                    }
        
                    this.isLoading = false
                }
                this.isLoading = false
                this.submitted = false
            } catch(e) {
                console.log('error', e)
                this.showMess('error', 'Error', 'Error')
                this.isLoading = false
                this.submitted = false
            }

            return
        },
	},
    computed : {
        isAuth: function () { return this.$store.getters.isAuthenticated },
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        user_name: function () { return this.$store.getters.StateUserName },
        isTgApp: function () { return this.$store.getters.StateTgApp },
    },
	beforeCreate() {
        this.connect = new Connect()
        this.event = new Event(this)
        this.helper = new Helper()
    },
	async mounted() {
        // платежные системы | обязательно
        this.arrPaymetSystems = await PaymentSystemList.GetList(this.$store).then(r=>r)
        if (!this.arrPaymetSystems || this.arrPaymetSystems.length <= 0){
            this.totalError = true
            this.totalErrorMessage = 'No payment systems loaded' // TODO: вывести ошибку на разных языках
            return
        }
        // console.log('arrPaymetSystems', this.arrPaymetSystems)

        // валюты | обязательно
        const resCurrencies = await CurrencyList.GetList(this.$store).then(r=>r)
        if (!resCurrencies || resCurrencies.length <= 0){
            this.totalError = true
            this.totalErrorMessage = 'No currencies loaded' // TODO: вывести ошибку на разных языках
            return
        }
        this.arrCurrencies = CurrencyList.ToObjectMap(resCurrencies)
        // console.log('arrCurrencies', this.arrCurrencies)

        // банки | обязательно
        this.arrBanks = await BankList.GetList(this.$store).then(r=>r)
        if (!this.arrBanks || this.arrBanks.length <= 0){
            this.totalError = true
            this.totalErrorMessage = 'No banks loaded' // TODO: вывести ошибку на разных языках
            return
        }
        // console.log('arrBanks', this.arrBanks)

        // Курсы доступных валют | обязательно
        const resRates = await this.connect.GetRatesByType('bill').then(res => res)
        if (!resRates.result || !resRates.data || resRates.data.length <= 0){
            this.totalError = true
            if(resRates.errors && resRates.errors.length > 0) this.totalErrorMessage = resRates.errors[0]
            else this.totalErrorMessage = 'No rates loaded'
            return
        }
        // проверяем на обязательные поля
        const objRates = new RateList(resRates.data)
        this.arrRates = objRates.toArrayObj()
        // console.log('rates', this.arrRates)

        this.loaded = true
        this.react.recalculating_ = true
        this.recalculating = true

        this.Recalculate('start').then(res => {
            this.react.recalculating_ = false
            this.recalculating = false
        })
	}
}
</script>